import ThumbImage from './ThumbImage';

export default ThumbImage;
